module.exports = __webpack_public_path__ + "static/media/5.a053208d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Editor/images/5.svg
// module id = 916
// module chunks = 0